import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import HeaderBlock from '../../primitives/HeaderBlock'
import CtaButton from '../../primitives/CtaButton'
import { Link } from 'gatsby'
import {
  HeroWrapper,
  TextWrapper,
  GraphicWrapper,
  ButtonWrapper,
  InnerContent,
  BottomBar,
  MobileGraphic,
  Vector,
} from './Hero.styles'

const Hero = ({
  cta,
  graphic,
  bgColor,
  buttonBg,
  heroText,
  subText,
  spanText,
  headMax,
  subMax,
  slug,
  vectors,
  pad,
  imgMobileMargin,
  breakP,
  max,
  innerMax,
  accent,
  textPad,
  children,
  showOverflow,
  mobileVectors,
  mobileVectorsBreakP,
  barPad,
  mobileBar,
}) => {
  return (
    <>
      <HeroWrapper bgColor={bgColor} showOverflow={showOverflow}>
        {!!vectors &&
          vectors.map((vectorObj, i) => (
            <Vector
              key={`vector_${i}`}
              style={{ ...vectorObj.styles }}
              breakP={mobileVectorsBreakP}
            >
              {vectorObj.vector}
            </Vector>
          ))}
        {!!mobileVectors &&
          mobileVectors.map((vectorObj, i) => (
            <MobileGraphic
              breakP={mobileVectorsBreakP}
              key={`mobile-vector_${i}`}
              style={vectorObj.styles}
            >
              {vectorObj.vector}
            </MobileGraphic>
          ))}
        <InnerContent breakP={breakP} innerMax={innerMax}>
          <TextWrapper headMax={headMax} breakP={breakP} textPad={textPad}>
            <HeaderBlock
              spanText={spanText}
              breakP={breakP}
              pad="0"
              horizontalAlign="flex-start"
              textAlign="left"
              headerText={heroText}
              subText={subText}
              bgColor="transparent"
              accent={accent}
              subMax={subMax}
            />
            {!!slug && (
              <ButtonWrapper breakP={breakP}>
                <CtaButton {...cta} slug={slug} bgColor={buttonBg} minW="220px">
                  {cta?.ctaText || 'Get Started'}
                </CtaButton>
              </ButtonWrapper>
            )}
            {children}
          </TextWrapper>
          <GraphicWrapper max={max} pad={pad} imgMobileMargin={imgMobileMargin}>
            <GatsbyImage loading="eager" image={graphic} alt="Banner Image" />
          </GraphicWrapper>
        </InnerContent>
      </HeroWrapper>
      {mobileBar && (
        <Link to={mobileBar.to}>
          <BottomBar
            breakP={breakP}
            barPad={barPad}
            barMargin={mobileBar.barMargin}
          >
            <p>{mobileBar.text}</p>
          </BottomBar>
        </Link>
      )}
    </>
  )
}

Hero.defaultProps = {
  bgColor: `white`,
  vectors: null,
  textPad: null,
}

Hero.propTypes = {
  graphic: PropTypes.object.isRequired,
  bgColor: PropTypes.string,
  vectors: PropTypes.array,
  textPad: PropTypes.string,
}

export default Hero
